/**
 * Table Cell Component.
 *
 * @author Ryan Johnston <ryan.johnston@scalesology.com>
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import childrenPropType from 'js/PropTypes/children';

/**
 * Table Cell Class
 */
class Cell extends Component {
    static propTypes = {
        children: childrenPropType,
        className: PropTypes.string,
    };

    static defaultProps = {
        children: null,
        className: null,
    };

    /**
     * Render the table cell.
     *
     * @returns {React.node}
     */
    render() {
        const { children, className } = this.props;

        return (
            <td className={className}>
                {children}
            </td>
        );
    }
}

export default Cell;
